
import Button from '../../../components/base/Button';

export default function ServicesSection() {
  const services = [
    {
      id: 'buy-sell',
      title: '売買仲介',
      description: 'マンション・一戸建て・土地の売買をトータルサポート。市場分析から契約まで安心してお任せください。',
      icon: 'ri-home-line',
      image: 'https://public.readdy.ai/ai/img_res/748d4e47c6145ea3a0df03c040c8f3db.jpg.%20The%20atmosphere%20should%20convey%20trust%2C%20professionalism%2C%20and%20successful%20real%20estate%20transactions.%20Clean%2C%20minimalist%20background%20with%20natural%20lighting.&width=400&height=300&seq=service-buy-sell&orientation=landscape',
      features: ['市場価格査定', '購入サポート', '売却サポート', '住宅ローン相談']
    },
    {
      id: 'rental',
      title: '賃貸仲介',
      description: '豊富な賃貸物件の中からライフスタイルに合った最適な住まいをご提案いたします。',
      icon: 'ri-key-line',
      image: 'https://readdy.ai/api/search-image?query=Modern%20apartment%20interior%20showing%20a%20beautifully%20furnished%20living%20room%20with%20natural%20light%20streaming%20through%20large%20windows.%20The%20space%20should%20feel%20welcoming%20and%20comfortable%2C%20representing%20the%20ideal%20rental%20property.%20Contemporary%20furniture%2C%20clean%20lines%2C%20and%20a%20warm%2C%20inviting%20atmosphere%20with%20professional%20interior%20photography%20lighting.&width=400&height=300&seq=service-rental&orientation=landscape',
      features: ['物件紹介', '契約サポート', '引越しサポート', '更新手続き']
    },
    {
      id: 'management',
      title: '賃貸管理',
      description: 'オーナー様の大切な資産を適切に管理し、安定した収益確保をサポートします。',
      icon: 'ri-building-line',
      image: 'https://readdy.ai/api/search-image?query=Professional%20property%20management%20concept%20showing%20a%20modern%20apartment%20building%20exterior%20with%20well-maintained%20landscaping%20and%20a%20property%20manager%20reviewing%20documents.%20The%20scene%20should%20convey%20reliability%2C%20professional%20property%20care%2C%20and%20successful%20investment%20management.%20Clean%20architectural%20photography%20with%20blue%20sky%20background.&width=400&height=300&seq=service-management&orientation=landscape',
      features: ['入居者募集', '家賃収納代行', '物件メンテナンス', 'トラブル対応']
    }
  ];

  return (
    <section className="py-16 bg-white">
      <div className="container mx-auto px-4">
        <div className="text-center mb-12">
          <h2 className="text-4xl font-bold text-gray-900 mb-4">
            サービス案内
          </h2>
          <p className="text-xl text-gray-600 max-w-2xl mx-auto">
            お客様のニーズに合わせた幅広いサービスをご提供しています
          </p>
        </div>
        
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-8">
          {services.map((service) => (
            <div key={service.id} className="bg-white rounded-2xl shadow-lg overflow-hidden hover:shadow-xl transition-shadow">
              <div className="relative h-48">
                <img
                  src={service.image}
                  alt={service.title}
                  className="w-full h-full object-cover object-top"
                />
                <div className="absolute top-4 left-4 w-12 h-12 flex items-center justify-center bg-blue-600 rounded-full text-white">
                  <i className={`${service.icon} text-xl`}></i>
                </div>
              </div>
              
              <div className="p-6">
                <h3 className="text-2xl font-bold text-gray-900 mb-3">
                  {service.title}
                </h3>
                <p className="text-gray-600 mb-4 leading-relaxed">
                  {service.description}
                </p>
                
                <div className="mb-6">
                  <h4 className="font-semibold text-gray-900 mb-2">主なサービス内容</h4>
                  <ul className="space-y-1">
                    {service.features.map((feature, index) => (
                      <li key={index} className="flex items-center text-sm text-gray-600">
                        <i className="ri-check-line text-blue-600 mr-2"></i>
                        {feature}
                      </li>
                    ))}
                  </ul>
                </div>
                
                <Button variant="outline" className="w-full">
                  詳細を見る
                </Button>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
